import { Box, Flex } from '@chakra-ui/react';
import { useLocationQuery } from 'generated/graphql';
import { Outlet, useParams } from 'react-router-dom';
import Suites from '../../Suites';
import Header from './Header';

function Location() {
  const { locationId } = useParams() as { locationId: string };
  const { loading, data } = useLocationQuery({
    variables: { id: locationId },
  });

  if (loading || !data) return null;

  return (
    <Flex direction="column" height="100%" bg="white" borderRadius="2xl" boxShadow="md">
      <Header location={data.location} />
      <Box flex={1} p={4} overflow="scroll">
        <Suites location={data.location} />
      </Box>
      <Outlet />
    </Flex>
  );
}

export default Location;
